import { LayerDefinition } from './types';

export const wildfiresDefinition: LayerDefinition = {
  id: 'wildfires',
  name: 'Wildfire Perimeters & Info',
  category: 'environment',
  categoryLabel: 'Environmental & Air Quality',
  icon: '🔥',
  description: 'Displays active wildfire perimeters across the United States (NIFC) and Canada (CWFIS), alongside near-real-time satellite thermal anomaly hotspots detected by NASA VIIRS instruments (375m resolution). Includes acreage, containment progress, and incident reporting.',
  sourceModels: [
    'NIFC WFIGS (National Interagency Fire Center)',
    'CWFIS (Canadian Wildland Fire Information System)',
    'NASA FIRMS VIIRS (375m Active Fire Detections)'
  ],
  outputModels: ['Vector Perimeters & Point Hotspots GeoJSON'],
  config: {
    hotspots: true,
    cadence: 'Daily / Sub-Daily'
  }
};

export default wildfiresDefinition;
